import { styled as e } from "styled-components";
//#region src/components/DatePicker/styled/DatePicker.styled.ts
var t = e.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${({ theme: e }) => e.spacing(.5)};
    width: 100%;
`, n = e.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme: e }) => e.spacing(1)};
    width: 100%;
    /* Match the default (md) Input: 52px tall, 16px horizontal padding, 1px border. */
    height: 52px;
    padding: 0 ${({ theme: e }) => e.spacing(2)};
    background: ${({ theme: e }) => e.colors.card};
    border: 1px solid
        ${({ theme: e, $error: t, $open: n }) => t ? e.colors.destructive : n ? e.colors.primary : e.colors.input};
    border-radius: ${({ theme: e }) => e.radii.md};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.base};
    color: ${({ theme: e }) => e.colors.foreground};
    text-align: left;
    cursor: ${({ $disabled: e }) => e ? "not-allowed" : "pointer"};
    opacity: ${({ $disabled: e }) => e ? .5 : 1};
    transition: border-color ${({ theme: e }) => e.transitions.fast};

    &:hover:not(:disabled) {
        border-color: ${({ theme: e }) => e.colors.primary};
    }
    &:focus-visible {
        outline: none;
        border-color: ${({ theme: e }) => e.colors.primary};
        box-shadow: 0 0 0 3px ${({ theme: e }) => e.colors.primary}28;
    }
`, r = e.span`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1)};
    min-width: 0;
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`, i = e.span`
    color: ${({ theme: e }) => e.colors.mutedForeground};
`, a = e.button`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: none;
    border: none;
    cursor: pointer;
    color: ${({ theme: e }) => e.colors.mutedForeground};
    border-radius: ${({ theme: e }) => e.radii.sm};
    padding: 2px;
    &:hover {
        color: ${({ theme: e }) => e.colors.foreground};
    }
`;
//#endregion
export { a as ClearBtn, i as Placeholder, t as Root, n as Trigger, r as TriggerInner };
